<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <person-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import PersonForm from "./Form"
import model from "./model"

export default {
  components: { PersonForm },
  data() {
    return { model }
  },
}
</script>
